/* global ga -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import 'bootstrap';

import '../plugins/dl-menu/js/jquery.dlmenu';
import './common/footer';
import './common/mobile.menu';
import TooltipPlugin from '@components/tooltip';
import PopoverPlugin from '@components/popover';
import RangeSliderPlugin from '@components/range-slider';
import MultiselectPlugin from '@components/multiselect';
import PeityChartsPlugin from '@components/peity-charts';
import KnobPlugin from '@components/knob';
import CirclifulPlugin from '@components/circliful';
import CounterUpPlugin from '@components/counter-up';
import NavBar from '@components/nav-bar';

$(() => {
    $('.sidebar_button a').on('click', () => {
        ga('send', 'event', 'Blog', 'Apply_Now_Clicked', 'Click Apply Now Button');
    });

    TooltipPlugin.init($);
    PopoverPlugin.init($);
    RangeSliderPlugin.init($);
    MultiselectPlugin.init($);
    PeityChartsPlugin.init($);
    KnobPlugin.init($);
    CirclifulPlugin.init($);
    CounterUpPlugin.init($);
    NavBar.init($);
});
